/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvZWotdHMvYWRtaW4tcG9ydGFsL3RlbmFudC1yZWdpc3RyYXRpb24vdGVuYW50LXJlZy1yZXN1bHQvdGVuYW50LXJlZy1yZXN1bHQuY29tcG9uZW50LmNzcyJ9 */"];
export { styles as styles };
